<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title>Tools</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-card outlined class="mb-4">
              <v-card-text>
                <v-subheader>Attendance</v-subheader>
                <v-list>
                  <v-list-item @click="openReport">
                    <v-list-item-avatar tile>
                      <v-icon>mdi-chart-box-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        Attendance By Student
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>

            <v-card outlined>
              <v-card-text>
                <v-subheader>Report Card</v-subheader>
                <v-list>
                  <v-list-item @click="openGrades">
                    <v-list-item-avatar tile>
                      <v-icon>mdi-counter</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>Grades</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <BottomNavigation />
  </v-app>
</template>
  
<script>
import BottomNavigation from "@/modules/Layout/components/BottomNavigation.vue";
export default {
  name: "tools",
  data() {
    return {};
  },
  components: {
    BottomNavigation,
  },
  methods: {
    openReport() {
      this.$router.push({ path: "/report" });
    },
    openGrades() {
      this.$router.push({ path: "/reportCard/grades" });
    },
  },
};
</script>  